export default class ModuleDetailModel {
  constructor(data, targetId) {
    const target = data.find((el) => el.id === targetId);
    const {
      id,
      title,
      icon,
      customList
    } = target;

    this.id = id;
    this.title = title;
    this.icon = icon.image.url;
    this.list = customList.filter((el) => el.courses.length >= 1).map((el) => ({
      id: el.id,
      name: el.name
    }));
  }

  static fromRes(data, id) {
    return new ModuleDetailModel(data, id);
  }
}
